import React from "react";
import IconHeader from "./IconHeader";
import classnames from "classnames";
import "./IconSteps.scss";

interface IconStepsProps {
  isActive?: boolean;
  isVerified?: boolean;
  stepNumber?: number;
  stepLabel?: string;
  form?: React.ReactNode;
}

const verificationCheckMark = () => {
  return (
    <svg
      className="verification-checkmark"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 52 52"
    >
      <circle
        className="verification-checkmark__circle"
        cx="26"
        cy="26"
        r="25"
        fill="none"
      />
      <path
        className="verification-checkmark__check"
        fill="none"
        d="M14.1 27.2l7.1 7.2 16.7-16.8"
      />
    </svg>
  );
};

const IconSteps = ({
  isActive,
  isVerified,
  stepNumber,
  stepLabel,
  form,
}: IconStepsProps) => {
  let label: React.ReactNode = stepLabel;
  if (isActive) {
    label = <IconHeader variant="iconBanner" headerText={stepLabel} />;
  } else if (isVerified) {
    label = (
      <IconHeader
        variant="labelHeader"
        headerText={stepLabel}
        style={{ fontWeight: 400 }}
      />
    );
  } else {
    label = (
      <IconHeader
        variant="labelHeader"
        headerText={stepLabel}
        style={{ fontWeight: 400 }}
      />
    );
  }

  return (
    <div className="icon-steps">
      <div className="icon-step-container">
        {isVerified ? (
          verificationCheckMark()
        ) : (
          <div
            className={classnames("step-circle", {
              "is-active": isActive,
            })}
          >
            {stepNumber}
          </div>
        )}

        <div className="step-label">{label}</div>
      </div>
      {form && <div style={{ marginLeft: 40 }}> {form}</div>}
    </div>
  );
};

export default IconSteps;
